export default "__VITE_ASSET__d53de3d4__"